import type { Object3D } from 'three';

const SOURCE_HIGHLIGHT_MARKER_KEY = '__puppyCadSketchEntityReferenceSourceHighlight';

/**
 * 标记对象为草图实体引用来源高亮对象。
 *
 * @param object 需要写入来源高亮标记的对象。
 */
export function markSketchEntityReferenceSourceHighlight(object: Object3D): void {
	Reflect.set(object, SOURCE_HIGHLIGHT_MARKER_KEY, true);
}

/**
 * 清理对象上的草图实体引用来源高亮标记。
 *
 * @param object 需要移除来源高亮标记的对象。
 */
export function clearSketchEntityReferenceSourceHighlight(object: Object3D): void {
	Reflect.deleteProperty(object, SOURCE_HIGHLIGHT_MARKER_KEY);
}

/**
 * 判断对象是否已被标记为草图实体引用来源高亮对象。
 *
 * @param object 需要判断的对象。
 * @returns 若对象已被标记则返回 true。
 */
export function isSketchEntityReferenceSourceHighlight(object: Object3D): boolean {
	return Reflect.get(object, SOURCE_HIGHLIGHT_MARKER_KEY) === true;
}
